module.exports = __webpack_public_path__ + "img/app-go.8afc4942.png";